// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './lang';
import rum from './tool/rum';
import store from './store'
import axios from 'axios'

Vue.use(rum, {
  app_id: process.env.NODE_ENV == 'production' ? 'web_vip_mall.global.prod':'web_vip_mall.global.sandbox',
  env: process.env.NODE_ENV
})

axios.defaults.withCredentials = true
//axios.defaults.headers['x-requested-with'] = 'new'

Vue.config.productionTip = false
Vue.config.errorHandler = function (err, vm, info) {
  console.error(err);
  vm.$rum.errorReport(err, vm, info)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js